document.querySelectorAll('.toggleBtn').forEach((btn) => {
  btn.addEventListener('click', () => {
    const nextEl = btn.nextElementSibling;
    if (nextEl && nextEl.classList.contains('globalnav-sub')) {
      nextEl.classList.toggle('is-active');
    }
  });
});

document.querySelectorAll('.back').forEach((btn) => {
  btn.addEventListener('click', () => {
    const ancestor = btn.closest('.globalnav-sub');
    if (ancestor) {
      ancestor.classList.remove('is-active');
    }
  });
});

document.querySelectorAll('.childback').forEach((btn) => {
  btn.addEventListener('click', () => {
    const ancestor = btn.closest('.child-nav');
    if (ancestor) {
      ancestor.classList.remove('is-active');
    }
  });
});

document.querySelectorAll('.gnav-list-sub__item .parents').forEach((el) => {
  el.addEventListener('click', () => {
    const parentItem = el.closest('.gnav-list-sub__item');
    const childNav = parentItem.querySelector('.child-nav');
    if (childNav) {
      childNav.classList.add('is-active');
    }
  });
});






const swiperElement = document.querySelector('.swiper');
if (swiperElement) {
	const swiper = new Swiper(swiperElement, {
		loop: true,
		slidesPerView: 'auto',
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
			pauseOnMouseEnter: false,
		},
		speed: 6000,
		freeMode: {
			enabled: true,
			momentum: false,
		},
		allowTouchMove: false,
	});
}
